import React from 'react';
import Select from 'react-select/creatable';

export const UsersSearchSelect = ({ users, onChange, className }) => (
    <Select
        className={className}
        onChange={option => onChange(option.value)}
        options={makeUsersOptions(users)}
        isValidNewOption={() => false}
    />
);

const makeUsersOptions = users =>
    users &&
    users.map(player => ({
        label: `${player.firstName} ${player.lastName}`,
        value: player
    }));
